import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2dfa4a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-edit-box" }
const _hoisted_2 = { class: "switch-line-box" }
const _hoisted_3 = {
  key: 0,
  class: "tips-box"
}
const _hoisted_4 = { class: "option-list-box" }
const _hoisted_5 = { class: "date-range-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "至", -1))
const _hoisted_7 = { class: "date-range-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分钟", -1))
const _hoisted_9 = { class: "field-edit-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ui_switch = _resolveComponent("ui-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, { "label-width": "100px" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "字段名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              maxlength: "25",
              placeholder: "请输入字段名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "输入提示" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.placeholder,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.placeholder) = $event)),
              maxlength: "50",
              placeholder: "请输入输入框提示文案"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "字段类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.form.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.type) = $event)),
              style: {"width":"100%"},
              onChange: _ctx.changeType
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.name,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ui_switch, {
                trueValue: 1,
                falseValue: 0,
                modelValue: _ctx.form.isRequire,
                "onUpdate:modelValue": _ctx.changeRequire
              }, {
                default: _withCtx(() => [
                  _createTextVNode("必填")
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"]),
              (_ctx.form.isSystem == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "系统字段，报名时一定会带上，且不允许删除"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_ctx.isOptionType)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "选项"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "option-item-box",
                      key: index
                    }, [
                      _createVNode(_component_el_input, {
                        modelValue: item.name,
                        "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                        placeholder: "选项名称"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_input, {
                        modelValue: item.value,
                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                        placeholder: "选项值"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_el_link, {
                        type: "danger",
                        underline: false,
                        onClick: ($event: any) => (_ctx.removeOption(index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128)),
                  _createVNode(_component_el_link, {
                    type: "primary",
                    underline: false,
                    onClick: _ctx.addOption
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("+ 添加选项")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isDateType)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "可选时间"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.form.content.weekDays,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.content.weekDays) = $event)),
                  class: "week-checkbox-box"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.value,
                        label: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isDateType)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "可约时间"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_time_picker, {
                    modelValue: _ctx.form.content.startTime,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.content.startTime) = $event)),
                    "value-format": "HH:mm",
                    placeholder: "开始时间"
                  }, null, 8, ["modelValue"]),
                  _hoisted_6,
                  _createVNode(_component_el_time_picker, {
                    modelValue: _ctx.form.content.endTime,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.content.endTime) = $event)),
                    "value-format": "HH:mm",
                    placeholder: "结束时间"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isDateType)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "时间间隔"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.form.content.interval,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.content.interval) = $event)),
                    min: 1,
                    step: 5,
                    "controls-position": "right"
                  }, null, 8, ["modelValue"]),
                  _hoisted_8
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('reject')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      })
    ])
  ]))
}